export default __webpack_public_path__ + "static/media/YMCA.c358a9cb.png";